module.exports = __webpack_public_path__ + "media/images/logo_full-1d09d89417123f64477eaade5ec4e1f9.png";